<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>同捆列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">同捆编号:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.tongkunNo"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">收件人:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.receiverName"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">用户ID:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.userName"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">客户姓名:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.realName"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title" style="text-align:right">状态:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.status" placeholder="请选择" size="small" clearable>
                  <el-option value="1" label="发送中"></el-option>
                  <el-option value="3" label="已到齐"></el-option>
                  <el-option value="5" label="等待到库"></el-option>
                  <el-option value="7" label="已发送"></el-option>
                  <el-option value="9" label="已取消"></el-option>
                </el-select>
              </div>
            </el-col> -->

          </el-row>
          <el-row class="search-row">
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">No:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.orderId"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">物流公司:</div>
              <div class="flex1">

                <el-select
                  v-model="queryInfo.configLogisticsCompanyId"
                  placeholder="请选择"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="item in LogisticsCompanyList"
                    :key="item.id"
                    :label="item.companyName"
                    :value="item.id"
                  >
                  </el-option>

                </el-select>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">国际运单号:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.trackingNumberJpn"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">创建开始日:</div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">

          <el-col
            :span="6"
            class="display-row"
          >
            <div class="query-title">创建结束日:</div>
            <div class="flex1">
              <el-date-picker
                clearable
                v-model="queryInfo.createTimeEnd"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </el-col>

          <el-col
            :span="6"
            class="display-row"
          >
            <div class="query-title">发送开始日:</div>
            <div class="flex1">
              <el-date-picker
                clearable
                v-model="queryInfo.completeTimeStart"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col
            :span="6"
            class="display-row"
          >
            <div class="query-title">发送结束日:</div>
            <div class="flex1">
              <el-date-picker
                clearable
                v-model="queryInfo.completeTimeEnd"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </el-col>
          <!-- <el-col :span="6" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
            </div>
          </el-col> -->
        </el-row>
        </el-collapse>
        <el-row class="search-row">

          <el-col
            :span="18"
            class="display-row"
          >
            <div class="search-btn-container search-btn-container-status">
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === ''}"
                @click="changeTab('')"
              >全部</el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 5}"
                @click="changeTab(5)"
              >等待到库<span class="lx-red">({{orderCount.waitWarehouseCount}})</span></el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 3}"
                @click="changeTab(3)"
              >已到齐<span class="lx-red">({{orderCount.arrivedCount}})</span></el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 2}"
                @click="changeTab(2)"
              >申请发货<span class="lx-red">({{orderCount.applySendCount}})</span></el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 4}"
                @click="changeTab(4)"
              >已打包<span class="lx-red">({{orderCount.packedCount}})</span></el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 6}"
                @click="changeTab(6)"
              >待支付<span class="lx-red">({{orderCount.waitPayCount}}</span>)</el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 1}"
                @click="changeTab(1)"
              >待发送<span class="lx-red">({{orderCount.sendingCount}})</span></el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 7}"
                @click="changeTab(7)"
              >已发送<span class="lx-red"></span></el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 9}"
                @click="changeTab(9)"
              >已取消<span class="lx-red"></span></el-button>
            </div>
          </el-col>
          <el-col
            :span="6"
            class="display-row"
          >
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button
                class="search-btn btn-gray"
                @click="queryInfoClear"
              >重置</el-button>
              <el-button
                class="search-btn btn-blue"
                @click="searchList()"
              >搜索</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive" >展开</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive" >收起</el-button>
              <!-- <el-button
                class="search-btn btn-green"
                @click="exportAction"
              >导出</el-button> -->
            </div>
          </el-col>
        </el-row>
      </div>
      <div
        slot="table"
        class="full-height display-col"
      >
        <el-table
          :data="recordList"
          border
          style="width: 100%"
          height="550"
          v-loading="isLoading"
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="40"
          ></el-table-column>
          <el-table-column
            label="订单操作"
            align="center"
            width="80"
          >
            <template v-slot="scope">
              <div class="btn-row">
                <el-button
                  class="list-btn-four btn-blue"
                  @click="toOrderDetail(scope.row)"
                >
                  同捆详情
                </el-button>
              </div>
              <div
                class="btn-row"
                v-if="showSplitOrderBtn(scope.row)"
              >
                <el-button
                  class="list-btn-four btn-green"
                  @click.native="handleOpen(scope.row.id)"
                >拆分同捆
                </el-button>
              </div>
              <div
                class="btn-row"
                v-if="showSendBill(scope.row.status)"
              >
                <el-button
                  class="list-btn-four btn-red"
                  @click="addSendBill(scope.row)"
                >发送账单</el-button>
              </div>
              <div
                class="btn-row"
                v-if="showBill(scope.row.status)"
              >
                <el-button
                  class="list-btn-four btn-blue"
                  @click="addBill(scope.row)"
                >账单</el-button>
              </div>
              <div
              class="btn-row"
              v-if="scope.row.status!=9"
              >
                <el-button
                class="list-btn-four btn-deepblue"
                @click="ModifyTk(scope.row)">
                  编辑
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="用户ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="realName"
            label="用户姓名"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="tongkunNo"
            label="同捆编号"
            width="90"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            sortable
            :index="indexMethod"
            align="center"
            width="120"
            label="同捆创建时间"
          >
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            align="center"
            :index="indexMethod"
            sortable
            width="100"
            label="同捆状态"
          >
            <template v-slot="scope">
              {{ tongkunStatusShow(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            align="center"
            :index="indexMethod"
            sortable
            width="100"
            label="国际物流"
          >
            <template v-slot="scope">
              <div class="btn-row">
                {{scope.row.trackingNumberJpn}}
              </div>
              <div
                class="btn-row overflowDot"
                :title="scope.row.sagawaState"
              >
                {{scope.row.logisticsState}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="completeTime"
            sortable
            :index="indexMethod"
            align="center"
            width="120"
            label="同捆发送日"
          >
            <template v-slot="scope">
              {{ scope.row.completeTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column
            prop="receiverName"
            width="160"
            label="收件信息"
          >
            <template v-slot="scope">
              <div>
                <span>收件人：</span>
                <span>{{scope.row.receiverName}}</span>
              </div>
              <div>
                <span>收件地址：</span>
                <span>{{scope.row.receiverAddress}}</span>
              </div>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--              prop="receiverAddress"-->
          <!--              label="收件地址">-->
          <!--          </el-table-column>-->
          <el-table-column
            align="center"
            prop="orderCount"
            :index="indexMethod"
            sortable
            width="160"
            label="同捆数"
          >
            <template v-slot="scope">
              <div>
                <span>同捆数：</span>
                <span>{{scope.row.orderCount}}</span>
              </div>
              <div>
                <span>同捆到货数：</span>
                <span>{{scope.row.arrivalCount}}</span>
              </div>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--              prop="arrivalCount"-->
          <!--              :index="indexMethod"  sortable-->
          <!--              label="同捆到货数">-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="locatorNo"
            label="库位"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="orderId"
            label="订单号"
            align="center"
            min-width="100"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <!-- 修改页面 -->
    <el-dialog
        :visible.sync="ModifyPageVisible"
        width="61%"
        title="修改同捆"
        @close="ModifyPageClosed"
    >
      <el-form
          :model="ModifyTKOrderInfo"
          :rules="rules"
          ref="dialogForm"
          class="demo-userInfo"
      >
        <el-form-item label="同捆编号:" label-width="120px">
          <el-input v-model="ModifyTKOrderInfo.tongkunNo" style="width: 200px" size="small"
                    disabled></el-input>
        </el-form-item>

        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="库位：" prop="configLocatorId" label-width="120px">

              <el-select v-model="ModifyTKOrderInfo.configLocatorId" placeholder="请选择" size="small" clearable>
                <el-option
                    v-for="item in dropDownList"
                    :key="item.id"
                    :label="item.locatorNo"
                    :value="item.id">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="物流公司：" prop="configLogisticsCompanyId" label-width="120px">

              <el-select v-model="ModifyTKOrderInfo.configLogisticsCompanyId" placeholder="请选择" size="small" clearable>
                <el-option
                    v-for="item in LogisticsCompanyList"
                    :key="item.id"
                    :label="item.companyName"
                    :value="item.id">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="运单号：" prop="trackingNumberJpn" label-width="120px">
              <el-input v-model="ModifyTKOrderInfo.trackingNumberJpn" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="ModifyPageVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="replySave" type="primary">提 交</el-button>
      </span>

      <!-- </div>  -->

    </el-dialog>
    <lx-select-goods
      :id='id'
      :visible.sync="isVisiable"
      :selectList="renderWaybillDetailList"
      @confirm="onSelectGoods"
      @getrecordList="getrecordList"
    ></lx-select-goods>
  </div>
</template>

<script>
import tableCon from '../../../views/tableContainer'
import LxSelectGoods from '@/components/LxSelectGoods/index'
export default {
  components: { tableCon, LxSelectGoods },
  name:'buddleOrder',
  data () {
    return {
      isActive:false,
      ModifyPageVisible:false,
      //修改装箱单实体类
      ModifyTKOrderInfo: {
        tongkunNo: '',
        configLogisticsCompanyId: '',
        trackingNumberJpn: '',
        configLocatorId:''
      },
      //库位的下拉列表
      dropDownList: [],
      rules: {
        // logisticeCompany: [
        //   {required: true, message: '物流编号不能为空', trigger: 'blur'}
        // ],
        // logisticsCompanyId: [
        //   {required: true, message: '物流编号不能为空', trigger: 'blur'}
        // ],
        // trackingNumberJpn: [
        //   {required: true, message: '运单号不能为空', trigger: 'blur'}
        // ],
      },
      curIndex: '', // 默认选中第0个
      isVisiable: false, // 拆单
      waybillDetailList: [], // 选择的商品
      renderWaybillDetailList: [],
      isLoading: false,
      id: -1,
      queryInfo: {
        id: '',
        tongkunNo: '',
        receiverName: '',
        status: '',
        createTimeStart: '',
        createTimeEnd: '',
        completeTimeStart: '',
        completeTimeEnd: '',
        userName: '',
        realName: '',
        tongKun: '',
        orderId: '',
        configLogisticsCompanyId: '',
        trackingNumberJpn: '',
        pageSize: 10,
        pageNum: 1
      },
      LogisticsCompanyList: [],
      // orderDateRangeValue: [],
      orderDetailValue: {
        id: '',
        status: ''
      },
      recordList: [],
      orderCount: {
        total: 0,
        waitWarehouseCount: 0,
        arrivedCount: 0,
        applySendCount: 0,
        packedCount: 0,
        waitPayCount: 0,
        sendingCount: 0,
        sendCount: 0,
        cancelCount: 0
      },
      total: 0,
      // orderDateRangeValue2: []
    }
  },
  methods: {
    changeTab(index){
      this.curIndex=index
      this.searchList()
    },
    //修改同捆
    ModifyTk(row) {
      this.ModifyPageVisible = true;
      this.TKInfo = row;
      this.ModifyTKOrderInfo.tongkunNo = row.tongkunNo;
      this.ModifyTKOrderInfo = JSON.parse(JSON.stringify(row));
    },
    //保存修改同捆
    replySave() {
      this.modifyTKOrder()
    },
    async modifyTKOrder() {    //修改同捆
      var my = this;
      this.$refs.dialogForm.validate(async function (valid) {
        var url = 'tongkun/updateTkInfo';
        if(valid){
          const {data: res} = await my.$http.post(url, my.ModifyTKOrderInfo);
          if (res.code == 200) {
            my.$message({
              type: 'success',
              message: res.message
            }),
            my.ModifyPageVisible = false;
            my.getCount();
            my.getrecordList();
          } else {
            my.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },
    async getLocatorDropDownList() {
      const {data: res} = await this.$http.get("cms/locator/dropDownList");
      this.dropDownList = res.data;
    },
    ModifyPageClosed() {
      this.ModifyPageVisible = false;
    },
    async exportAction () {
      this.$http.get('/tongkun/checkLength', { params: this.queryInfo }).then(res => {
        if (res.data.code == 200) {
          this.$http({
            url: '/tongkun/exportAction',
            method: 'get',
            params: this.queryInfo,
            responseType: 'blob', // 表明返回服务器返回的数据类型
            headers: {
              'Content-Type': 'application/json'
            },
            data: {
              //接口参数
            }
          }).then((res) => {
            //创建一个隐藏的a连接，
            const link = document.createElement('a');
            let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
            link.style.display = 'none';
            //设置连接
            link.href = URL.createObjectURL(blob);
            link.download = '同捆发货列表.xlsx';
            document.body.appendChild(link);
            //模拟点击事件
            link.click();
          }).catch((err) => {
            alert(err.message)
          })
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'warning'
          });
        }
      });


    },
    addBill (e) {
      this.$router.push({
        path: 'buddleOrder/buddleOrderBill',
        query: {
          id: e.tongkunNo,
          isAdd: '0',
          //orderNumber:e.orderNumber,
        }
      })
    },
    //账单按钮显示  待支付6  待发送1  已完成7
    showBill (status) {
      if (status == 6 || status == 1 || status == 7) {
        return true;
      }
      else {
        return false;
      }
    },
    addSendBill (e) {
      this.$router.push({
        path: 'buddleOrder/buddleOrderBill',
        query: {
          id: e.id,
          isAdd: '1',
          //orderNumber:e.orderNumber,
        }
      })
    },
    //发送账单按钮显示  已打包4
    showSendBill (status) {
      if (status == 4) {
        return true;
      }
      else {
        return false;
      }
    },
    handleOpen (id) {
      this.isVisiable = true
      this.id = id
    },
    //按钮显示
    showSplitOrderBtn (row) {
      // if ((row.status == 3 || row.status == 5 || row.status == 2) && row.orderCount > 1) {
      if (row.status == 3 || row.status == 5 || row.status == 2) {
        return true;
      } else {
        return false;
      }
    },
    orderDateRange2 () {

    },
    onSelectGoods () { },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getCount();
      this.getrecordList();
    },
    //正常发送
    sendAction (row) {
      this.sendDeal(row)
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getCount();
      this.getrecordList();
    },
    orderDateRange () {

    },
    searchList () {    //查询
      this.queryInfo.status = this.curIndex
      this.queryInfo.pageNum = 1;
      this.getCount();
      this.getrecordList();
    },
    async getrecordList () {
      this.isLoading = true
      const { data: res } = await this.$http.get('/tongkun/list', { params: this.queryInfo });
      this.isLoading = false
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    async getCount () {
      const { data: res } = await this.$http.get('/tongkun/tongKunCount');
      this.orderCount = res.data;
    },
    async getDropDownList () {
      this.$http.post('/cms/logisticsCompany/getDropDownList').then(res => {
        this.LogisticsCompanyList = res.data.data;
      })
    },
    toOrderDetail (row) {
      this.$router.push({
        name: 'buddleOrderDetail',
        query: {
          id: row.id
        }
      })
    },
    sendDeal (row) {
      this.$confirm("确定申请发货此同捆批次吗？这会把同捆状态改为【发送中】，之后不会再有新的订单进入此同捆", "发货", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        this.orderDetailValue.id = row.id;
        this.orderDetailValue.status = '1';
        const { data: res } = await this.$http.post(`tongkun/updateAction/`, this.orderDetailValue);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          await this.getCount();
          await this.getrecordList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消修改"
        });
      });
    },
    queryInfoClear () {    //清空
        this.curIndex = ''
        this.queryInfo.status = '',
        this.queryInfo.createTimeStart= '',
        this.queryInfo.createTimeEnd= '',
        this.queryInfo.completeTimeStart= '',
        this.queryInfo.completeTimeEnd= '',
        this.queryInfo.receiverName= '',
        this.queryInfo.tongkunNo= '',
        this.queryInfo.userName= '',
        this.queryInfo.realName= '',
        this.queryInfo.tongKun= '',
        this.queryInfo.orderId= '',
        this.queryInfo.configLogisticsCompanyId= '',
        this.queryInfo.trackingNumberJpn= '',
        this.queryInfo.pageSize= 10,
        this.queryInfo.pageNum= 1
    },
    tongkunStatusShow (status) {
      switch (status) {
        case '1':
          return '待发送'
          break;
        case '2':
          return '申请发货'
          break;
        case '3':
          return '已到齐'
          break;
        case '4':
          return '已打包'
          break;
        case '5':
          return '等待到库'
          break;
        case '6':
          return '待支付'
          break;
        case '7':
          return '已发送'
          break;
        case '9':
          return '已取消'
          break;
      }
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    // orderDateRangeValue() {
    //   //解决时间选择器清空后 绑定值为null问题
    //   if (!this.orderDateRangeValue) {
    //     this.orderDateRangeValue = [];
    //     this.queryInfo.createTimeStart = '';
    //     this.queryInfo.createTimeEnd = '';
    //   } else {
    //     if (this.orderDateRangeValue.length > 0) {
    //       this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
    //       this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
    //     }
    //   }
    // },
    // orderDateRangeValue2() {
    //   //解决时间选择器清空后 绑定值为null问题
    //   if (!this.orderDateRangeValue2) {
    //     this.orderDateRangeValue2 = [];
    //     this.queryInfo.completeTimeStart = '';
    //     this.queryInfo.completeTimeEnd = '';
    //   } else {
    //     if (this.orderDateRangeValue2.length > 0) {
    //       this.queryInfo.completeTimeStart = this.orderDateRangeValue2[0];
    //       this.queryInfo.completeTimeEnd = this.orderDateRangeValue2[1];
    //     }
    //   }
    //
    // }
  },
  created () {
    this.getCount();
    this.getrecordList();
    this.getDropDownList();
    this.getLocatorDropDownList();
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
.search-btn-container-status {
  text-align: left !important;
}
</style>
